import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {ItemsGroup} from './itemsGroups';
import {TreeNode} from "primeng/api";

@Injectable()
export class ItemsGroupService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('itemsGroups?' + params.toString()).map((response: Response) => response.json());
  }
    getAllGroups(_id: any = 0) {
        return this.http.get('itemsGroups/all/' + _id ).map((response: Response) => response.json());
    }
  getById(_id: string) {
    return this.http.get('itemsGroups/' + _id).map((response: Response) => response.json());
  }
  getByname(_name: string,_id: any = 0) {
    return this.http.get('itemsGroupsfound/' + _id + "/" + _name).map((response: Response) => response.json());
  }

  getTree(_id:string) {
    return this.http.get('itemsGroups/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('itemsGroups/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('itemsGroups/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(itemsGroup: ItemsGroup) {
    return this.http.post('itemsGroups', itemsGroup).map((response: Response) => response.json());
  }

  update(itemsGroup: ItemsGroup) {
    return this.http.put('itemsGroups/' + itemsGroup.id, itemsGroup).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('itemsGroups/' + _id).map((response: Response) => response.json());
  }

  deletePic(_id: string) {
    return this.http.put('itemsGroups/picture/delete/' + _id,{}).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/itemsGroups/itemsGroups.service.ts